var BaseCodeLettersView = require('../codeLetters');


module.exports = BaseCodeLettersView.extend({


    MAX_PAGE_FONT_SIZE_PROPORTION: 0.10,

    /* Always print all codes on new lines */
    _getCodeTextToPrint: function( ) {

        return this.selectedCodes.getCodesAsString('\n');
    },

    /**
     * Utilize all logic from base:
     * - fontSize should be no longer than the longest line that will fit the width of the box
     * - verticalAdjustments: may not be necessary but utilize same logic as in base; perf shouldn't be hit too roughly
     * Then perform another vertical adjustment to cap the font-size
     */
    _getFontSize: function( sCodes, height, width, isWider ) {

        var fontSize = BaseCodeLettersView.prototype._getFontSize.apply( this, arguments );

        var pageProportionalFontSize = height * this.MAX_PAGE_FONT_SIZE_PROPORTION;

        return fontSize > pageProportionalFontSize
            ? pageProportionalFontSize
            : fontSize;

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/fullPageRedaction/codeLetters.js
 ** module id = 317
 ** module chunks = 0
 **/